import script from "./EloView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EloView.vue?vue&type=script&setup=true&lang=ts"

import "./EloView.vue?vue&type=style&index=0&id=a40491f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40491f0"]])

export default __exports__